import { render, staticRenderFns } from "./approvalRecord.vue?vue&type=template&id=7fa9b97c&scoped=true&"
import script from "./approvalRecord.vue?vue&type=script&lang=js&"
export * from "./approvalRecord.vue?vue&type=script&lang=js&"
import style0 from "./approvalRecord.vue?vue&type=style&index=0&id=7fa9b97c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa9b97c",
  null
  
)

export default component.exports